import maplibregl from 'maplibre-gl';
import config from '../config/config';

const DEFAULT_STYLE_NAME = config.map.defaultStyleName;
const DEFAULT_ANIMATION_DURATION_MS = Number(config.map.animationDurationMs);
const DEFAULT_PITCH = Number(config.map.defaultPitch);
const DEFAULT_BEARING = Number(config.map.defaultBearing);
const MAX_ZOOM = Number(config.map.zoomLevel.maxZoom);
const MIN_ZOOM = Number(config.map.zoomLevel.minZoom);

export function createMap(container, options = {}) {
  try {
    const mapInstance = new maplibregl.Map({
      container, // DOM要素を直接渡す
      style: options.style,
      center: options.center,
      zoom: options.zoom,
      pitch: options.pitch,
      bearing: options.bearing,
      minZoom: MIN_ZOOM,
      maxZoom: MAX_ZOOM,
      hash: false,
      interactive: true
    });
    return { map: mapInstance };
  } catch (error) {
    return { map: null };
  }
}

/**
 * 地図を北向きにリセットし、必要に応じて3Dモードも解除する
 * @param {Object} map - マップインスタンス
 * @param {boolean} is3dMode - 現在の3Dモード状態
 * @param {Function} setIs3dMode - 3Dモード状態更新関数
 * @param {Object} options - オプション設定（アニメーション時間など）
 * @returns {boolean} - 実行結果（成功: true、失敗: false）
 */
export function resetMapToNorth(map, is3dMode, setIs3dMode, options = {}) {
  if (!map) {
    return false;
  }

  try {
    // アニメーション時間
    const duration = Number(options.duration ?? DEFAULT_ANIMATION_DURATION_MS);

    // 地図の表示位置や角度をアニメーションしながら変更
    map.easeTo({
      bearing: Number(DEFAULT_BEARING),
      pitch: Number(DEFAULT_PITCH),
      duration: duration
    });

    // 3DモードONだった場合、解除する
    if (is3dMode) {
      // 3DモードボタンをOFFにする
      setIs3dMode(false);
    }
    return true;
  } catch (e) {
    return false
  }
}

/**
 * 地図をデフォルト設定（中心・ズーム・方位など）に戻す
 * @param {Object} map - マップインスタンス
 * @param {Object} defaultConfig - デフォルト設定オブジェクト
 * @param {Function} setIs3dMode - 3Dモード状態更新関数（省略可）
 * @param {Object} options - オプション設定（アニメーション時間など）
 * @returns {boolean} - 実行結果（成功: true、失敗: false）
 */
// 地図をデフォルトに戻す関数
export function resetMapToDefault(map, is3dMode, setIs3dMode, handleStyleChange, options = {}) {
  if (!map) {
    return false;
  }

  try {
    // 現在の中心座標とズームレベルを保持
    const currentCenter = map.getCenter();
    const currentZoom = map.getZoom();

    // アニメーション時間
    const duration = Number(options.duration ?? DEFAULT_ANIMATION_DURATION_MS);

    // デフォルトスタイルに変更
    handleStyleChange(DEFAULT_STYLE_NAME);

    // 傾斜と回転をリセット、中心座標とズームは保持
    map.easeTo({
      center: currentCenter,
      zoom: currentZoom,
      bearing: Number(DEFAULT_BEARING),
      pitch: Number(DEFAULT_PITCH),
      duration: duration
    });

    // 3DモードONだった場合、解除する
    if (is3dMode) {
      // 3DモードボタンをOFFにする
      setIs3dMode(false);
    }
    return true;
  } catch (e) {
    return false;
  }
}
